<script setup>
import {computed} from "vue";
import {useDisplay} from "vuetify";

const props = defineProps({
    vertical: {
        type: Boolean,
        default: false,
    }
});

const {width} = useDisplay();
const isVertical = computed(() => props.vertical || width.value < 768);
</script>

<template>
    <div class="wizard-summary" :class="{'wizard-summary--vertical': isVertical}">
        <slot></slot>
    </div>
</template>
